import {DKK, Package, Partner, Service} from "./index";

export class PackageTemplate {
  id: number;
  packageName: string;
  multiplier: number;
  discountPercentage: number;
  service: Service;

  constructor(service: Service, id: number, packageName: string, multiplier: number, discountPercentage: number) {
    this.id = id;
    this.packageName = packageName;
    this.service = service;
    this.multiplier = multiplier;
    this.discountPercentage = discountPercentage;
    this.service.addPackage(this);
  }

  private getPackages = (partner?: Partner): Package[] => {
    if (partner) {
      const pPackage = Package.fromPackageTemplate(this, partner);
      return [pPackage];
    } else {
      return this.service.getPartnersBy().reduce((p, partner) => {
        const newPackage = Package.fromPackageTemplate(this, partner);
        p.push(newPackage);
        return p;
      }, [] as Package[]);
    }
  };

  private getCheapestPackage = (partner?: Partner): Package => {
    const packages = this.getPackages(partner);
    const cheapest = packages.reduce((p, aPackage) => {
      const cheaper = p.getPrice() !== undefined && p.getPrice() < aPackage.getPrice() ? p : aPackage;
      return cheaper;
    });
    return cheapest;
  };

  private getLowestDiscountPackage = (partner?: Partner): Package => {
    const packages = this.getPackages(partner);
    const highestDiscounted = packages.reduce((p, aPackage) => {
      const higherDiscounted = p.getDiscountAmount() !== undefined && p.getDiscountAmount() < aPackage.getDiscountAmount() ? p : aPackage;
      return higherDiscounted;
    });
    return highestDiscounted;
  };

  public getSaveFromAndPriceFrom(partner?: Partner): {priceFrom: DKK; saveMin: DKK} {
    const priceFrom = this.getCheapestPackage(partner).getPrice();
    const saveMin = this.getLowestDiscountPackage(partner).getDiscountAmount();

    return {saveMin, priceFrom};
  }
}
